export default __webpack_public_path__ + "static/NPN-2units-871d54e0376c85169f324d04e3262a6a.png";